module.exports = __webpack_public_path__ + "img/ic-dash-appi.e8ddd3ee.svg";